<template>
  <div id="app"
       @click="close">
    <!-- nav -->
    <el-scrollbar class="app_scroll"
                  ref="elscrollbar"
                  v-show="$route.meta.scroll">
      <!-- {{!$route.meta.scroll}} -->
      <template v-if="$route.meta.scroll">
        <div class="com_nav_top">
          <div class="com_nav">
            <div class="logo base_banner"
                 v-bind:style="{'background-image':'url('+comPath+contactInfo.logimg+')'}"
                 @click="toHref('/',1)"></div>
            <!--            <div-->
            <!--              v-else-->
            <!--              class="logo base_banner"-->
            <!--              style="background:url('./assets/images/logo_about.png')"-->
            <!--            ></div>-->
            <div class="right_nav_info">
              <div class="nav_item about"
                   :class="{'activeNav':activeId==item.id || item.link === $route.path}"
                   @click="toHref(item.link,item.id)"
                   v-for="(item,index) in topNavList"
                   :key="index">{{item.menu_title}}</div>
              <div class="nav_item connect"
                   @click.stop="showContact">联系我们</div>
            </div>
          </div>
        </div>
        <connectUs ref="contactUS"
                   v-if="contactShow==true"
                   :class="{'slideInDown':contactShow,'fadeOutUp':!contactShow}"
                   @closeFather="clolseContact"
                   @clickSelf="clickSelf"
                   class="connectUs_box" />
        <div class="right_nav">
          <rightNav />
        </div>
        <div class="page_contain">
          <router-view @closeContact="getContactStatus" />
        </div>
        <Footer></Footer>
      </template>
    </el-scrollbar>
    <!--不包含滚动条  -->
    <div v-if="!$route.meta.scroll">
      <div class="com_nav_top"
           :class="{'nav_active':bgFlag}">
        <div class="com_nav">
          <div class="logo base_banner"
               v-bind:style="{'background-image':'url('+comPath+contactInfo.logimg+')'}"></div>
          <div class="right_nav_info">
            <div class="nav_item about"
                 :class="{'activeNav':activeId==item.id}"
                 @click="toHref(item.link,item.id)"
                 v-for="(item,index) in topNavList"
                 :key="index">{{item.menu_title}}</div>
            <div class="nav_item connect"
                 @click.stop="showContact">联系我们</div>
          </div>
        </div>
      </div>
      <connectUs ref="contactUS"
                 v-if="contactShow==true"
                 :class="{'slideInDown':contactShow,'fadeOutUp':!contactShow}"
                 @closeFather="clolseContact"
                 @clickSelf="clickSelf"
                 class="connectUs_box" />
      <div class="right_nav">
        <rightNav />
      </div>
      <div class="page_contain">
        <router-view @closeContact="getContactStatus" />
      </div>
    </div>

  </div>
</template>

<script>
import connectUs from "./views/connect_us";
import rightNav from "./components/right_nav";
import Footer from "./components/Footer.vue";
import { Scrollbar } from "element-ui";

export default {
  name: "App",
  // components: {

  // },
  data () {
    return {
      routeName: "Home",
      bgFlag: false,
      contactShow: false,
      contactInfo: {
        email: "",
        logimg: "",
        phone: "",
        qrcode: ""
      },
      topNavList: [],
      //bottomNavList: [],
      activeId: 1,
      Scrollheight: "" //滚动条滚动的高度
    };
  },
  watch: {
    $route (val) {
      this.routeName = val.name;
      this.activeId = this.$route.query.id
      if (this.$refs["elscrollbar"] && this.$refs["elscrollbar"].$refs["wrap"]) {
        this.toTop()
      }
    }
  },
  created () {
    console.log("8888888888")
    console.log(this.$route.query.id)
    if (this.$route.query.id || location.search.split("=")[1]) {
      //this.activeId = location.search.split("=")[1];
      this.activeId = this.$route.query.id || location.search.split("=")[1]
      // this.activeId = location.search.split("=")[1];
    }
    window.eventBus.$on("toTop", val => {
      this.toTop()

      //div.scrollTop = 0;
    });
  },
  mounted () {
    // document.onscroll = () => {
    //   if (document.documentElement.scrollTop > 0.5) {
    //     this.bgFlag = true;
    //   } else {
    //     this.bgFlag = false;
    //   }
    // };
    this.getCcontactInfo();
    this.getTopNavList();
    let div = this.$refs["elscrollbar"].$refs["wrap"];
    this.$nextTick(() => {
      div.addEventListener("scroll", this.onScroll);
      // console.log("进入页面时滚动条高度");
      // console.log(div.scrollTop);
    });
    window.eventBus.$on('closeContact', () => {
      this.getContactStatus()
    })

  },

  beforeDestroy () {
    document.onScroll = "";
  },
  methods: {
    toTop () {
      let div = this.$refs["elscrollbar"].$refs["wrap"];
      if (div.scrollTop == 0) {
        div.scrollTop = 0;
      } else {
        div.scrollTop = 0;
        // this.jump()
      }
    },
    clickSelf (e) {
      //e.preventDefault();
      e.stopPropagation(); //阻止事件冒泡
    },
    close (e) {
      this.contactShow = false;
    },
    getContactStatus () {
      this.contactShow = true;
    },
    getCcontactInfo () {
      let url = "/api/home/gainglobalstyle";
      this.$http.get(url).then(res => {
        // console.log("底部信息", res);
        if (res.data.ret === 0) {
          this.contactInfo.email = res.data.lister[0].email;
          this.contactInfo.logimg = res.data.lister[0].logimg;
          this.contactInfo.phone = res.data.lister[0].phone;
          this.contactInfo.qrcode = res.data.lister[0].qrcode;
        }
        // console.log(this.contactInfo);
      });
    },
    showContact () {
      this.contactShow = true;
    },
    clolseContact () {
      this.contactShow = false;
    },
    // 顶部导航
    getTopNavList () {
      let url = "/api/home/gainmenu";
      let params = {
        type_id: 1
      };
      this.$http.get(url, { params }).then(res => {
        if (res.data.ret === 0) {
          this.topNavList = res.data.lister;
          // console.log("顶部导航", res);

        }
      });
    },
    toHref (href, id) {
      //location.href = `${href}?id=${id}`;
      if (href === '/') {
        // this.$router.push({path: href})
        window.location.href = location.origin
      } else {
        this.$router.push({ path: href, query: { id: id } })
      }
      this.activeId = id
      this.$emit("close");
    },
    //监听滚动事件
    onScroll (e) {
      let div = this.$refs["elscrollbar"].$refs["wrap"];
      this.Scrollheight = div.scrollTop;
      if (div.scrollTop > 60) {
        this.bgFlag = true;
      } else {
        this.bgFlag = false;
      }
      window.eventBus.$emit(
        "handleHeight",
        this.Scrollheight
        // div.clientHeight,
        // this.isA
      );
    },
    //平滑跳动
    jump () {
      let div = this.$refs["elscrollbar"].$refs["wrap"];
      let distance = div.scrollTop; //滚动条距离顶部的距离
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = distance / 50;
      if (distance || distance == 0) {
        step = distance / 50;
        smoothUp();
      }
      function smoothUp () {
        distance -= step;
        div.scrollTop = distance;
        setTimeout(smoothUp, 0.1);
      }
    }
  },
  components: {
    connectUs,
    rightNav,
    Footer,
    ElScrollbar: Scrollbar
  }
};
</script>

<style lang="stylus" scoped>
@import './assets/css/baseFontAndColor.styl'
#app >>> .el-scrollbar__wrap
  padding-bottom 21px
  .el-scrollbar__view
    position relative
    margin-bottom -21px
    min-width 1210px
    min-height 100%
    width 100%
.el-scrollbar__bar
  z-index 111
  background red !important
  .el-scrollbar__thumb
    background red !important
.page_contain
  min-height 100vh
.right_nav
  position fixed
  top 50%
  right 20px
  z-index 9999999
  background #fff
  transform translateY(-50%)
.com_nav_top
  position fixed
  top 0
  left 0
  z-index 999
  width 100%
  height 60px
  background-color rgba(38, 38, 38, 0.8)
  /* background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.3) 51%, rgba(255, 255, 255, 0) 100%) */
  .com_nav
    display flex
    justify-content space-between
    align-items center
    margin 0 auto
    width 1200px
    height 60px
    .logo
      width 109px
      height 20px
      cursor pointer
      // background-image url("./assets/images/logo_about.png")
    .right_nav_info
      display flex
      justify-content space-around
      align-items center
      margin-right -25px
      width 512px
      color $color-main-main
      font-size $font-size-14
      .home
        width 28px
        height 20px
      .Market
        width 70px
        height 20px
      .service
        width 28px
        height 20px
      .about
        // width: 80px !important
        // line-height: 20px
        // text-align: center
        cursor pointer
      .nav_item
        color #fff
      .nav_item_active
        border-bottom 2px solid $color-theme-title
        color $color-theme-title
      .connect
        width 80px
        height 30px
        // border: 1px solid $color-theme-border
        background-color $color-theme-title
        color #fff
        text-align center
        line-height 30px
        cursor pointer
.nav_active
  background rgba(255, 255, 255, 1) !important
.connectUs_box
  position fixed
  top 0
  left 0
  z-index 9999999
  width 100%
  height 500px
.activeNav
  // text-decoration: underline
  border-bottom 2px solid #1CB3E4
  color $color-theme-title !important
#app
  position absolute
  overflow hidden
  width 100%
  height 100%
  background-color #f8f8f8
  font-family 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  .app_scroll
    height 100%
  .holder
    position absolute
    bottom 0
    left 0
    width 100%
    height 21px
    background-color #424242
</style>



// WEBPACK FOOTER //
// src/App.vue